import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { UserListComponent } from './pages/admin/users/user-list/user-list.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { ComponentListComponent } from './pages/component-list/component-list.component';
import { ComponentReportComponent } from './pages/component-report/component-report.component';
import { ComponentSnippetComponent } from './pages/component-snippet/component-snippet.component';
import { ComponentFormsContainerComponent } from './pages/component-forms-container/component-forms-container.component';
import { FileManagerComponent } from './pages/file-manager/file-manager.component';
import { ComponentNewComponent } from './pages/component-new/component-new.component';
import { ComponentPageContainerComponent } from './pages/component-page-container/component-page-container.component';
import { MaintenanceGuard } from './guards/maintenance.guard';

const appRoutes: Routes = [
	// Home is create component page
	{ path: '', component: ComponentNewComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'components', component: ComponentNewComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'component-report/:componentID', component: ComponentReportComponent, canActivate: [AuthGuard, MaintenanceGuard] },

	// Component
	{
		path: 'component',
		component: ComponentPageContainerComponent,
		canActivate: [AuthGuard, MaintenanceGuard],
		children: [
			{ path: '', redirectTo: '/components', pathMatch: 'full', canActivateChild: [AuthGuard, MaintenanceGuard] },
			{
				path: 'new',
				children: [
					{ path: '', redirectTo: '/components', pathMatch: 'full', canActivateChild: [AuthGuard, MaintenanceGuard] },
					{
						path: ':componentType/:templateNum',
						component: ComponentFormsContainerComponent,
						canActivateChild: [AuthGuard, MaintenanceGuard]
					},
					{ path: ':componentType', component: ComponentFormsContainerComponent, canActivateChild: [AuthGuard, MaintenanceGuard] }
				]
			},
			{
				path: 'edit',
				children: [
					{ path: '', redirectTo: '/components', pathMatch: 'full', canActivateChild: [AuthGuard, MaintenanceGuard] },
					{ path: ':componentID', component: ComponentFormsContainerComponent, canActivateChild: [AuthGuard, MaintenanceGuard] }
				]
			},
			{
				path: 'duplicate',
				children: [
					{ path: '', redirectTo: '/components', pathMatch: 'full', canActivateChild: [AuthGuard, MaintenanceGuard] },
					{ path: ':duplicateID', component: ComponentFormsContainerComponent, canActivateChild: [AuthGuard, MaintenanceGuard] }
				]
			},
			{ path: ':componentID', component: ComponentSnippetComponent, canActivateChild: [AuthGuard, MaintenanceGuard] }
		]
	},
	// Component List
	{
		path: 'component-list/:view/:start/:type/:name/:srv/:sortOrder/:sortDirection',
		component: ComponentListComponent,
		canActivate: [AuthGuard, MaintenanceGuard]
	},
	{ path: 'component-list/:view/:start/:type/:name/:srv', component: ComponentListComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'component-list/:view/:start/:type/:name', component: ComponentListComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'component-list/:view/:start/:type', component: ComponentListComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'component-list/:view/:start', component: ComponentListComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'component-list/:view', component: ComponentListComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'component-list', component: ComponentListComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	// File Manager
	{ path: 'file-manager/:view/:start/:order/:type', component: FileManagerComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'file-manager/:view/:start/:order', component: FileManagerComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'file-manager/:view/:start', component: FileManagerComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'file-manager/:view', component: FileManagerComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	{ path: 'file-manager', component: FileManagerComponent, canActivate: [AuthGuard, MaintenanceGuard] },
	// Admins
	{
		path: 'admin/users/:start/:esp/:name/:order/:type',
		component: UserListComponent,
		canActivate: [AuthGuard, AdminGuard, MaintenanceGuard]
	},
	{ path: 'admin/users/:start/:esp/:name', component: UserListComponent, canActivate: [AuthGuard, AdminGuard, MaintenanceGuard] },
	{ path: 'admin/users/:start/:esp', component: UserListComponent, canActivate: [AuthGuard, AdminGuard, MaintenanceGuard] },
	{ path: 'admin/users/:start', component: UserListComponent, canActivate: [AuthGuard, AdminGuard, MaintenanceGuard] },
	{ path: 'admin/users', component: UserListComponent, canActivate: [AuthGuard, AdminGuard, MaintenanceGuard] },
	//  Login & other types (default)
	{ path: 'login', component: LoginComponent, pathMatch: 'full' },
	{ path: 'maintenance', component: MaintenanceComponent, pathMatch: 'full' },
	{ path: '**', component: ComponentNewComponent, canActivate: [MaintenanceGuard] }
];

export const AppRouting: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes, {
	scrollOffset: [0, 0],
	scrollPositionRestoration: 'enabled'
});
